<template>
  <div>
    <div id="deliveryWrapper" :class="isDownload ? 'deliveryWrapper2' : 'deliveryWrapper'"
         v-if="itemDetail">
      <div class="deliveryHeader">
        <b class="com">嘉好企業有限公司</b><br/>
        <!--<span class="date">108年2月11日</span>-->

        <div class="detail">
          總公司:07-3822888<span class="nb">NO:{{itemDetail.displayId}}</span>
          <span  class="date">{{getCurrentDate}}</span>
          <br/>
          客戶:{{itemDetail.store.name}}&nbsp;&nbsp;地址：{{itemDetail.store.city}}{{itemDetail.store.area}}{{itemDetail.store.address}}&nbsp;&nbsp;電話:{{itemDetail.store.phone}}
        </div>
      </div>
      <table class="table">
        <tr>
          <th width="30px"></th>
          <th width="260px">品名</th>
          <th width="70px">數量</th>
          <th width="70px">單價</th>
          <th width="80px">總金額</th>
          <th>備註</th>
        </tr>
        <tr v-for="(product, i) in itemDetail.productList" :key="i">
          <td class="txtC">{{i+1}}</td>
          <td>
            {{product.id}}{{product.name}}{{getCategory(i)}}{{product.productNumber}}
          </td>
          <td class="nb2">1</td>
          <td></td>
          <td class="money">{{ product.price }}</td>
          <td rowspan="11" class="ps" v-if="i === 0">
            <h6>ABV系統</h6>
            <span>
                                安裝CCH機車<br/>
                                電腦(ECU)<br/>
                                注意事項:<br/>
                                安裝好ECU後<br/>
                                需打開Key鑰匙<br/>
                                等待40秒後發動機車<br/>
                                發動後一定要怠速<br/>
                                <b>八分鐘</b>等待學習完成
                            </span>
          </td>
        </tr>
        <tr v-for="(startIndex) in 10 - itemDetail.productList.length"
            :key="itemDetail.productList.length + startIndex">
          <td class="txtC">{{itemDetail.productList.length + startIndex}}</td>
          <td></td>
          <td class="nb2"></td>
          <td></td>
          <td class="money"></td>
        </tr>
        <tr>
          <td class="txtC"></td>
          <td colspan="3" class="total">總計新台幣<span class="nb3">萬</span><span class="nb3">千</span><span class="nb3">百</span><span class="nb3">拾</span><span class="nb3">元</span></td>
          <td class="money">{{getTotal}}</td>
        </tr>
      </table>
      <div class="sign">聯絡人：總公司&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;電話：07-3822888<span>經手人：{{itemDetail.agent ? itemDetail.agent.displayName : '--'}}</span>
      </div>
      <div class="sign">※{{itemDetail.comment}}</div>
      <div class="rPS">一&nbsp;&nbsp;式&nbsp;&nbsp;三&nbsp;&nbsp;聯</div>
    </div><!--wrapper-->
    <v-layout row v-else>
    </v-layout>
  </div>
</template>

<script>
    // import htmlToImage from 'html-to-image';
    import lineShare from "line-share";
    import { mapActions, mapGetters } from 'vuex';
    import MobileDetect from 'mobile-detect';
    const md = new MobileDetect(window.navigator.userAgent);
    export default {
        name: "DeliveryNoteView",
        data(){
            return {
                width: md.phone() ? "80%" : "70%",
                itemDetail: null,
                isPrint: false,
                startIndex: 0,
                loading: false,
                isDownload: false,
            }
        },
        created(){
          this.loadOrderInfo();
        },
        computed: {
            ...mapGetters(['getUserInfo']),
            getCurrentDate(){
                const now = new Date(this.itemDetail.deliveryDate);
                return `${now.getFullYear()-1911}年${now.getMonth()+1}月${now.getDate()}日`;
            },
              getIndex(){
                  if (this.itemDetail.productList) {
                      return this.itemDetail.productList ? this.itemDetail.productList.length : 0;
                  }
                  return 0;
              },
            getTotal(){
                if (this.itemDetail.price === ''){
                    return this.itemDetail.total;
                }

                let total = 0;
                this.itemDetail.productList.forEach(product=>{
                    total += parseInt(product.price);
                });
                return total;
            },
        },
        methods: {
            ...mapActions(['orderInfo','uploadBlobData']),
            async loadOrderInfo(){
              const deliveryId = this.$route.query.deliveryId;
              this.isPrint = this.$route.query.isPrint === 'true';
              this.isDownload = this.$route.query.isDownload === 'true';

              console.log(`deliveryId == ${deliveryId}`);
              const res = await this.orderInfo({ deliveryId: deliveryId});
              const result = res.data;
              if (result.statusCode === 0){
                this.itemDetail = result.data;
                console.log(`productList == ${JSON.stringify(this.itemDetail)}`);
                if (this.itemDetail && this.isPrint){
                  this.$nextTick(function () {
                    setTimeout(() => {
                      window.print();
                      window.close();
                    }, 500);
                  });
                }
              }
            },
            getCategory(i){
                if (this.itemDetail.productList) {
                    if (this.itemDetail.productList[i].category === 0){
                        return '整新品';
                    } else if (this.itemDetail.productList[i].category === 1){
                        return '維修交換品';
                    } else  if (this.itemDetail.productList[i].category === 2){
                        return '維修品';
                    } else  if (this.itemDetail.productList[i].category === 3){
                        return '故障品';
                    } else {
                        return '整新品';
                    }
                } else {
                    return '';
                }
            },
            // downloadImage(){
            //     this.loading = true;
            //     const wrapper = document.getElementById('deliveryWrapper');
            //     htmlToImage.toBlob(wrapper, { quality: 0.95, width:  wrapper.innerWidth , height: wrapper.innerHeight})
            //         .then((blob) => {
            //             this.uploadBlobData(blob).then(result=>{
            //                 this.loading = false;
            //                 console.log(`downloadImage == ${result}`);
            //                 if (this.itemDetail){
            //                     this.itemDetail.url = result;
            //                     this.saveDeliveryNote(this.itemDetail);
            //                 }
            //             })
            //         });
            // },
            shareToLine(){
                if (this.itemDetail){
                    const line = new lineShare();
                    line.share(this.itemDetail.url);
                }
            },
            saveImage(){
                if (this.itemDetail){
                    window.open(this.itemDetail.url);
                }
            },
            copy(){
                if (this.itemDetail){
                    const input = document.createElement('input');
                    input.setAttribute('value', this.itemDetail.url);
                    document.body.appendChild(input);
                    input.select();
                    document.execCommand('copy');
                    document.body.removeChild(input);
                    this.$message('已複製網址！');
                }
            }
        }
    }
</script>

<style scoped>
    html, body{height: 100%;}
    body {
        width: 100%;
        background: #fff ;
        font-family: Arial,"黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
        font-size: 12px;
        color:#000;
        padding:0;
        margin:0;
    }
    ul, li { display: block; padding:0;}
    table {
        width:100%;
        border-collapse:collapse;
        border-spacing:0;
    }

    .deliveryWrapper {
        position: relative;
        padding: 0 10px 45px;
        width: 750px;
        height: 480px;
        margin:0 auto;
        color: #000;
        background-color: white;
        font-family:Arial,"黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
    }

    .deliveryWrapper2 {
        position: relative;
        padding: 0 10px 45px;
        width: 750px;
        height: 480px;
        /*margin:0 auto;*/
        color: #000;
        background-color: white;
        font-family:Arial,"黑體-繁", "微軟正黑體", "Microsoft JhengHei", "新細明體", Helvetica, sans-serif;
    }

    .txtL { text-align: left}
    .txtR { text-align: right}
    .txtC { text-align: center;}
    .fwB { font-weight: bold;}

    /*---------------------------------------layout--*/

    .deliveryHeader {
        width:700px;
        padding-top: 22px;
        line-height: 26px;
        background: url(../assets/images/delivery_logo.jpg) no-repeat 225px 10px;
        background-size: 220px auto;
    }
    .deliveryHeader b.com { font-size: 22px}
    .deliveryHeader span.date {
        /*text-align: center;*/
        /*float: right; */
        margin-left: 100px;
        font-size: 17px
    }
    .deliveryHeader span.nb { float: right; font-size: 15px}
    .deliveryHeader .detail { font-size: 20px; margin-top: 3px}


    .table { width: 700px;}
    .table th, .table td { border:1px solid #000; }
    .table th { font-size: 20px; line-height: 20px}
    .table td { font-size: 16px; padding:3px; line-height: 18px ; border: 1px solid #000}
    .table td.nb2 { font-size: 18px; text-align: center;}
    .table td.money { font-size: 18px; text-align: right;}
    .table td.total { font-size: 18px;}
    .table span.nb3 { display: inline-block; text-align: right; width: 60px}
    .table td.ps { vertical-align: top; font-size: 18px;}
    .table td.ps h6 { font-size: 20px; font-weight: bold; margin:0; margin-bottom: 5px}
    .table td.ps span { line-height: 25px}

    .sign { width: 700px; font-size: 20px;}
    .sign span { display: inline-block; margin-left: 150px}
    .rPS {
        position: absolute;
        width:20px;
        right:0;
        top:285px;
        font-size: 16px;
        text-align: center;
        -webkit-writing-mode: vertical-lr;
        writing-mode: vertical-lr ;
    }

</style>



// WEBPACK FOOTER //
// src/components/DeliveryNoteView.vue